export type GuardianAutonomyBannerTone = 'safe'|'warning'|'danger';

export function guardianAutonomyBanner(input:{mode:string;autonomousResponseEnabled:boolean;featureEnabled:boolean}):{label:string;tone:GuardianAutonomyBannerTone}{
  if (input.mode !== 'test_autonomy' || !input.autonomousResponseEnabled) return {label:'OBSERVER · RECOMMENDATION ONLY',tone:'safe'};
  if (!input.featureEnabled) return {label:'AUTONOMY KILL SWITCH OFF · RECOMMENDATION ONLY',tone:'warning'};
  return {label:'TEST AUTONOMY · REAL PROVIDER WRITES ENABLED',tone:'danger'};
}
